import { render } from "./BaseNavBar.vue?vue&type=template&id=641040be&scoped=true"
import script from "./BaseNavBar.vue?vue&type=script&lang=js"
export * from "./BaseNavBar.vue?vue&type=script&lang=js"

import "./BaseNavBar.vue?vue&type=style&index=0&id=641040be&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-641040be"]])

export default __exports__